var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/stable/useActions.ts
import { useMemo } from "react";
import { makeActivityId } from "../__internal__/activity/index.mjs";
import { useCoreActions } from "../__internal__/core/index.mjs";
import { useTransition } from "../__internal__/shims/index.mjs";
function parseActionOptions(options) {
  if (!options) {
    return { skipActiveState: false };
  }
  const isNullableAnimateOption = options.animate == null;
  if (isNullableAnimateOption) {
    return { skipActiveState: false };
  }
  return { skipActiveState: !options.animate };
}
function useActions() {
  const coreActions = useCoreActions();
  const [pending] = useTransition();
  return useMemo(
    () => ({
      pending,
      push(activityName, activityParams, options) {
        const activityId = makeActivityId();
        coreActions == null ? void 0 : coreActions.push({
          activityId,
          activityName,
          activityParams,
          skipEnterActiveState: parseActionOptions(options).skipActiveState
        });
        return {
          activityId
        };
      },
      replace(activityName, activityParams, options) {
        var _a;
        const activityId = makeActivityId();
        coreActions == null ? void 0 : coreActions.replace({
          activityId: (_a = options == null ? void 0 : options.activityId) != null ? _a : makeActivityId(),
          activityName,
          activityParams,
          skipEnterActiveState: parseActionOptions(options).skipActiveState
        });
        return {
          activityId
        };
      },
      pop(count, options) {
        let _count = 1;
        let _options = {};
        if (typeof count === "object") {
          _options = __spreadValues({}, count);
        }
        if (typeof count === "number") {
          _count = count;
        }
        if (options) {
          _options = __spreadValues({}, options);
        }
        for (let i = 0; i < _count; i += 1) {
          coreActions == null ? void 0 : coreActions.pop({
            skipExitActiveState: i === 0 ? parseActionOptions(_options).skipActiveState : true
          });
        }
      }
    }),
    [coreActions == null ? void 0 : coreActions.push, coreActions == null ? void 0 : coreActions.replace, coreActions == null ? void 0 : coreActions.pop, pending]
  );
}
export {
  useActions
};
